function filtrarUsuarioIA(lista, campoNome = 'nome') {
    if (!Array.isArray(lista)) return [];
    const key = campoNome === 'USRNOMCPL' ? 'USRNOMCPL' : campoNome;
    const keyLower = key === 'USRNOMCPL' ? 'usrnomcpl' : (key === 'nome' ? 'Nome' : key);
    return lista.filter((item) => {
        const valor = item[key] ?? item[keyLower] ?? '';
        const nome = String(valor).trim();
        return nome.toUpperCase() !== 'IA';
    });
}

export default filtrarUsuarioIA;
